module.exports = "pegasus/assets/text-button-with-background-preview.png";